import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import RiskMatrix from "./RiskMatrix";
import MonteCarloSimulation from "./MonteCarloSimulation";
import firebase from "firebase/compat/app";
import CVSSCalculator from "./components/CVSSCalculator";

const Chapter7_3 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Welches Ziel hat das Common Vulnerability Scoring System (CVSS)?",
      options: [
        {
          value: "A",
          label:
            "Es bietet eine standardisierte Methode zur Bewertung und Priorisierung von Schwachstellen basierend auf ihrer Schwere.",
        },
        {
          value: "B",
          label:
            "Es dient der Verschlüsselung von sensiblen Daten, um diese vor unbefugtem Zugriff zu schützen.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Was ist das Ziel der Risikobewertung in der Cybersecurity?",
      options: [
        {
          value: "A",
          label:
            "Das Ziel ist es, Bedrohungen und Schwachstellen nach der Identifikation mit Wahrscheinlichkeiten und Auswirkungen zu unterlegen.",
        },
        {
          value: "B",
          label:
            "Das Ziel ist es, alle bestehenden Risiken vollständig zu eliminieren.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 7_3.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "7_3",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("7_3"),
            });
          console.log("Dokument aktualisiert mit Kapitel 7_3.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "7_3",
              completedChapters: ["7_3"],
            });
          console.log("Dokument erstellt mit Kapitel 7_3");
        }

        navigate("/cybersecurity/7_4"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  7. IT-Risikomanagement
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Risikobewertung
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 7: IT-Risikomanagement
          </h3>
          <h2 className="text-center pb-5">Risikobewertung</h2>
          <img
            src="/images/risikobewertung.png"
            alt="Risikobewertung"
            style={{ position: "relative", maxWidth: "20%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">Was ist die Risikobewertung? </h2>
          <p className="col-lg-11 pb-5 mx-auto">
            Nachdem die Risiken identifiziert wurden, müssen sie bewertet und priorisiert werden. Dabei wird nicht nur die Wahrscheinlichkeit
            eines Sicherheitsvorfalls berechnet. Es werden auch die potenziellen
            Auswirkungen auf das Unternehmen erfasst. So kann man fundierte
            Entscheidungen treffen, welche Sicherheitsmaßnahmen zuerst vorgenommen werden sollten, um die Risiken zu minimieren.
          </p>
        </div>
        <div className="grey-section">
          <div className="container p-5">
            <div className="p-5 ">
              <h2 className="p-5 col-lg-11  text-center mx-auto">
                Methoden der Risikobewertung
              </h2>
              <p className="col-lg-11 pb-3 text-center mx-auto">
                Damit ein Zustand überhaupt messbar gemacht werden kann, gibt es
                verschiedene Methoden, um Bedrohungen und
                Schwachstellen systematisch zu analysieren und zu bewerten. Unterschieden werden die  <strong>qualitative </strong>
                und die <strong>quantitative </strong>Risikobewertung. Beide
                Methoden helfen, Risiken einzustufen und Prioritäten für
                Sicherheitsmaßnahmen zu setzen.
              </p>
              <h3 className="p-5"> Qualitative Risikobewertung</h3>
              <p className="col-lg-11 text-center mx-auto">
                Die qualitative Risikobewertung ist ein einfacher und oft
                schneller Ansatz, um Risiken anhand von Erfahrungswerten und
                subjektiven Einschätzungen zu bewerten. Anstatt genaue
                Zahlenwerte zu nutzen, werden Risiken in Wort-Kategorien wie
                „hoch“, „mittel“ oder „niedrig“ eingestuft. Diese
                Kategorisierung ermöglicht eine flexible und schnelle
                Einschätzung, insbesondere wenn detaillierte Daten fehlen. Dazu
                werden zwei Fragen beantwortet: <br />
                <br />
                <strong>
                  1. Wie wahrscheinlich ist es, dass ein Risiko eintritt?
                </strong>
                <br />
                <br />
                Hier wird die <strong>Wahrscheinlichkeit </strong>eines Vorfalls
                geschätzt, z. B. in Kategorien wie „hoch“, „mittel“ oder
                „niedrig“. Diese Bewertung hilft, die Bedrohungen einzuschätzen,
                die am wahrscheinlichsten eintreten könnten.
                <br />
                <br />
                <strong>
                  2. Wie groß wäre der Schaden, wenn das Risiko eintritt?
                </strong>
                <br />
                <br />
                Dann wird subjektiv beurteilt, welche <strong>Auswirkungen </strong>ein
                Vorfall auf das Unternehmen hätte, ebenfalls in Kategorien wie
                „hoch“, „mittel“ oder „niedrig“. Zum Beispiel könnte ein Risiko
                mit „hoher Auswirkung“ große finanzielle Schäden oder einen
                Reputationsverlust mit indirekten Erfolgswirkungen durch zukünftige Ertragseinbußen verursachen.
                <br />
                <br />
                Diese beiden Einschätzungen (Wahrscheinlichkeit und Auswirkung)
                werden dann in einer <strong>Risikomatrix </strong> kombiniert.
                Mit der Risikomatrix wird ein Überblick über die wichtigsten
                Risikobereiche visuell dargestellt. So können die Bedrohungen,
                die am wahrscheinlichsten eintreten und den größten Schaden
                verursachen könnten, schnell identifiziert und priorisiert
                werden.
                <br />
                <br />
                In dieser Risikomatrix sind die Risiken auf einer vertikalen
                Achse mit der Wahrscheinlichkeit und einer horizontalen Achse
                mit der Auswirkung eingetragen:
              </p>
              <p className="col-lg-8 text-center mx-auto">
                <RiskMatrix />
                <br />
                <br />
              </p>{" "}
              <p className="col-lg-11 text-center mx-auto">
                Risiken im „roten“ und „orangefarbenen“ Bereich erfordern
                priorisierte Maßnahmen, um die wichtigsten Bedrohungen zu
                mindern. Mit dieser Matrix können Unternehmen ihre Ressourcen
                gezielt auf die besonders kritischen Schwachstellen konzentrieren und so
                eine wirksame Risikoreduzierung erreichen.
              </p>
            </div>
          </div>
        </div>

        <div className="gelb-section">
          <div className="container p-5">
            <div className="p-5 ">
              <h3 className="p-5"> Quantitative Risikobewertung</h3>
              <p className="col-lg-11 text-center mx-auto">
                Im Gegensatz zur subjektiven Vorgehensweise einer qualitativen Risikobewertung basiert die quantitative Risikobewertung auf messbaren Daten. Hier wird versucht, Risiken mit monetären oder numerischen Werten
                darzustellen. Der Vorteil dieses Ansatzes liegt in der objektiven
                Messbarkeit, die eine exaktere Analyse und Vergleichbarkeit
                von Risiken ermöglicht. <br />
                <br />
                Um ein Risiko in Zahlen zu überführen, werden zuerst der <strong> Monetary Loss </strong> (finanzieller Verlust) und dessen Eintrittswahrscheinlichkeit er??. Daraus lassen sich in einem nächsten Schritt der  <strong> Expected Monetary Loss </strong> (der erwartete finanzielle Verlust) EML und der <strong> Unexpected Monetary Loss </strong> (der unerwartete finanzielle Verlust) UEML berechnen. 
            
                <br />
                <br />
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">
                      Berechnungsmethode des Expected Monetary Loss
                    </h5>

                    <div className="p-3 rounded mb-3">
                      <h5>Formel:</h5>
                      <div className="display-6 text-center">
                       <h4> EML = Wahrscheinlichkeit × Schadenswert </h4>
                      </div>
                    </div>

                    <div className="p-3 rounded">
                      <h5>Beispielberechnung:</h5>
                      <div className="calculation-details">
                        <p className="lead">
                          <strong>
                            {" "}
                            Wahrscheinlichkeit eines Cyberangriffs: 5%
                          </strong>
                        </p>
                        <p className="lead">
                          <strong> Potenzieller Schaden: €500,000</strong>
                        </p>
                        <p className="lead fw-bold text-danger border-top pt-3">
                          EML = 0.05 × €500,000 = €25,000
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </p>
              <p className="col-lg-11 text-center mx-auto">
                Hier wird die Wahrscheinlichkeit eines Vorfalls mit Hilfe statistischer Beobachtungswerte validiert.  Dieser Wert wird mit dem
                potenziellen finanzielle Schaden multipliziert, der durch den
                Vorfall entstehen könnte, z. B. durch Betriebsunterbrechungen,
                Datenverlust oder Wiederherstellungskosten.<br /><br />Der UEML wird mit Hilfe statistischer Methoden, z. B. der Standardabweichung quantifiziert. Der UEML zeigt, wie sehr die eine?? finanziellen Verluste um den EML herum schwanken. 
              </p>

              <h4 className="p-5">
                {" "}
                Monte Carlo Simulation für die quantitative Risikobewertung
              </h4>
              <p className="col-lg-11 text-center mx-auto">
                Die Monte-Carlo-Simulation ist eine Methode zur Risikobewertung,
                bei der Computersimulationen genutzt werden, um die
                Wahrscheinlichkeit und die Auswirkungen verschiedener möglicher Ergebnisse mit Hilfe von Zufallszahlenzu
                simulieren. In der Cybersecurity wird die Monte-Carlo-Simulation
                verwendet, um Unsicherheiten und potenzielle Bedrohungen zu
                analysieren und die Auswirkungen unterschiedlicher
                Sicherheitsrisiken besser zu verstehen. Durch die Simulation
                vieler möglicher Szenarien kann die Methode helfen, fundierte
                Entscheidungen zu treffen und Ressourcen gezielter einzusetzen.
              </p>
              <h5 className="p-3">
                {" "}
                Wie funktioniert die Monte-Carlo-Simulation in der
                Cybersecurity?
              </h5>

              <section class="p-5 col-lg-9 mx-auto text-start">
                <ul class="timeline">
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">1. Definition der Variablen:</h5>

                    <p>
                      Zunächst werden die wichtigsten Variablen und deren
                      Unsicherheiten identifiziert. In der Cybersecurity könnten
                      das z. B. die Häufigkeit von Cyberangriffen, die Höhe des
                      potenziellen Schadens oder die Wahrscheinlichkeit für eine
                      bestimmten Schwachstelle sein.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">
                      2. Festlegung der Wahrscheinlichkeitsverteilungen:
                    </h5>

                    <p>
                      Für die Eintrittswahrscheinlichkeit und die Auswirkungen werden Verteilungensfunktionen festgelegt. Die Verteilungsfunktionen beschreiben, wie diese Werte nach oben oder unten schwanken. So könnte z. B.
                      die Schadenshöhe einer Datenschutzverletzung einer
                      Normalverteilung folgen. 
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">3. Simulationsläufe:</h5>

                    <p>
                      Ein Computer führt Tausende oder sogar Millionen von
                      Simulationsläufen durch, in denen die Werte der Variablen
                      zufällig ausgewählt werden. Jeder
                      Lauf stellt ein mögliches Szenario dar.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">4. Ergebnisse analysieren</h5>

                    <p>
                      Die Simulation ergibt eine computersimulierte Verteilung möglicher
                      Ergebnisse. Durch einen Blick auf die mögliche zukünftige Verteilung von Schadensereignissen können die
                      Wahrscheinlichkeiten und potenziellen Auswirkungen von
                      Sicherheitsvorfällen besser abgeschätzt und Verlustszenarien besser beurteilt werden. 
                    </p>
                  </li>
                </ul>
              </section>
              <h5 className="p-3">
                {" "}
                Beispiel für eine Monte-Carlo-Simulation in der Cybersecurity
              </h5>

              <p className="col-lg-11 text-center mx-auto">
                <br />
                Angenommen, ein Unternehmen möchte das Risiko eines
                erfolgreichen{" "}
                <Link to="/cybersecurity/2_4" className="icon-link">
                  {" "}
                  <svg className="bi" aria-hidden="true">
                    {" "}
                    <use xlinkHref="#book"></use>{" "}
                  </svg>{" "}
                  Phishing{" "}
                </Link>
                -Angriffs bewerten und mögliche finanzielle Verluste abschätzen.
                Die Monte-Carlo-Simulation kann dabei helfen, die potenziellen
                Auswirkungen solcher Angriffe im Laufe eines Jahres zu
                simulieren und den erwarteten Verlust sowie seine Variabilität
                darzustellen. <br />
                <br />
                Einstiegsvariablen: <br />
                <br />
                <ul>
                  <ol>
                    <strong>
                      Variable 1: Die Wahrscheinlichkeit eines Phishing-Angriffs
                      liegt bei 5 % pro Monat.
                    </strong>
                  </ol>
                  <ol>
                    <strong>
                      Variable 2: Die Schadenshöhe eines erfolgreichen Angriffs
                      beträgt durchschnittlich 500.000 €, kann aber um ±20 %
                      variieren.
                    </strong>
                  </ol>
                </ul>
                <br />
               In dieser Simulation wird jeder Monat eines Jahres betrachtet. Für jeden Monat wird mit einer Zufallszahl entschieden, ob ein erfolgreicher Phishing‑Vorfall eintritt (mit 5% Wahrscheinlichkeit). Tritt ein Vorfall ein, wird der Schaden zufällig im Bereich von ±20% um 500.000 € gewählt (also ca. 400.000–600.000 €) und zum Jahresverlust addiert. Dieser Prozess wird über viele Durchläufe (z. B. 1.000 oder mehr) wiederholt.
              </p>
              <MonteCarloSimulation />

              <p className="col-lg-11 text-center mx-auto">
                <br />
                <br />
               Nach Abschluss erhält der Nutzer den durchschnittlichen Jahresverlust sowie Minimal‑ und Maximalwert. Zusätzlich wird die Verteilung der Jahresverluste grafisch dargestellt (z. B. als Histogramm), sodass man typische Fälle und seltene hohe Verluste erkennen kann.
Hinweis: Bei 5% pro Monat ist es normal, dass viele Jahre 0 € Verlust haben, weil in diesen Jahren kein erfolgreicher Vorfall eintritt.
                <br />
                <br />
                Die quantitative Risikobewertung bietet also eine datengestützte Methode zur Einschätzung von Risiken. Sie  ist
                besonders hilfreich, wenn genaue Daten verfügbar sind. Sie
                ermöglicht es Unternehmen, die Kosten von Sicherheitsmaßnahmen
                gegenüber den potenziellen Verlusten abzuwägen und fundierte
                Entscheidungen über Investitionen in ihre Cybersecurity zu
                treffen.
              </p>
             
             
            </div>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container p-5">
          <div className="p-3 ">
            <h3 className="p-5">CVSS zur Unterstützung der Risikobewertung</h3>
            <p className="col-lg-11 mx-auto">
              Sowohl bei der qualitativen als auch bei der quantitativen
              Bewertung von Cyberrisiken ist es wichtig, die{" "}
              <strong> technische Schwere </strong>
              von Schwachstellen richtig einzuschätzen. Das Common Vulnerability
              Scoring System (CVSS) liefert dafür einen standardisierten Wert,
              der zeigt, wie gefährlich und ausnutzbar eine Schwachstelle ist.
              CVSS wurde ursprünglich vom Forum of{" "}
              <Link to="/cybersecurity/4_5#ir" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Incident Response
              </Link>{" "}
              and Security Teams (FIRST) entwickelt und wird weltweit
              eingesetzt.
              <br />
              <br />
              In der qualitativen Bewertung kann CVSS helfen, Schwachstellen in
              Kategorien wie „niedrig“, „mittel“ oder „hoch“ einzuordnen, um
              Risiken klar zu priorisieren. In der quantitativen Bewertung kann
              der CVSS-Wert genutzt werden, um Wahrscheinlichkeiten und
              potenzielle Schäden in konkrete Zahlen zu übersetzen. <br />
              <br />
              Die Schwere einer Sicherheitslücke wird im CVSS mit einem
              numerischen Wert bewertet und einer Kategorie zugeordnet:
              <br />
              0,0: Keine Auswirkung, 0,1–3,9: Niedrig, 4,0–6,9: Mittel, 7,0–8,9:
              Hoch, 9,0–10,0: Kritisch
            </p>
            <h4 className="pt-5">Metrikgruppen</h4>

            <p className="col-lg-11 pt-3 mx-auto">
              CVSS besteht aus drei Metrikgruppen, die verschiedene Aspekte
              einer Sicherheitslücke bewerten:
            </p>
            <div className="col-lg-11 text-start mx-auto">
              <h5 className="pt-3 "> 1. Basis-Metriken:</h5>
              <p>
                Diese Metrik misst die grundlegenden Eigenschaften einer
                Sicherheitslücke, die unabhängig von zeitlichen oder
                umgebungsbedingten Faktoren konstant bleiben. Sie umfasst:
                <br />
                <br />
                <ul>
                  <li>
                    <strong>Angriffsvektor (Attack Vector) :</strong> Wie kann
                    die Schwachstelle ausgenutzt werden? (z. B. über das
                    Netzwerk, lokal, physisch),
                  </li>
                  <li>
                    <strong>Angriffskomplexität (Attack Complexity): </strong>
                    Wie schwierig ist der Angriff? (niedrig oder hoch),
                  </li>
                  <li>
                    <strong>Berechtigungsstufe (Privileges Required): </strong>
                    Sind spezielle Rechte notwendig, um die Lücke auszunutzen?
                    (keine, niedrig, hoch),
                  </li>
                  <li>
                    <strong>Benutzereinwirkung (User Interaction, UI): </strong>
                    Wird die Interaktion eines Nutzers benötigt? (ja/nein),
                  </li>
                  <li>
                    <strong>Vertraulichkeit (Confidentiality, C):</strong>{" "}
                    Beeinträchtigt die Lücke die Vertraulichkeit der Daten?
                    (niedrig, hoch),
                  </li>
                  <li>
                    <strong>Integrität (Integrity, I): </strong>
                    Wird die Datenintegrität kompromittiert? (niedrig, hoch),
                  </li>
                  <li>
                    {" "}
                    <strong>Verfügbarkeit (Availability, A): </strong>
                    Führt die Schwachstelle zu einer eingeschränkten oder nicht
                    verfügbaren Ressource? (niedrig, hoch).
                  </li>
                </ul>
              </p>

              <h5 className="pt-3"> 2. Temporäre Metriken</h5>
              <p>
                Diese Metrik berücksichtigt Faktoren, die sich im Laufe der Zeit
                ändern können, wie:
                <br /> <br />
                <ul>
                  <li>
                    <strong>Ausnutzbarkeit (Exploit Code Maturity): </strong>{" "}
                    Wie leicht kann die Lücke ausgenutzt werden?{" "}
                  </li>
                  <li>
                    <strong>Abhilfemaßnahmen (Remediation Level): </strong> Gibt
                    es einen Patch oder andere Maßnahmen zur Behebung?{" "}
                  </li>
                  <li>
                    <strong> Vertrauenswürdigkeit (Report Confidence): </strong>{" "}
                    Wie verlässlich ist die Informationsquelle?{" "}
                  </li>
                </ul>
              </p>
              <h5 className="pt-3"> 3. Umgebungsmetrik</h5>
              <p>
                Hier wird bewertet, wie die Schwachstelle spezifische Systeme
                oder Organisationen betrifft: <br /> <br />
                <ul>
                  <li>
                    <strong>Sicherheitsanforderungen: </strong> Wie wichtig sind
                    Vertraulichkeit, Integrität und Verfügbarkeit für die
                    Organisation?{" "}
                  </li>
                  <li>
                    <strong>Modifizierte Basiswerte: </strong> Anpassung der
                    Basismetriken für den spezifischen Kontext.
                    <br /> <br />
                  </li>
                </ul>
              </p>
            </div>
            <h4 className="p-5 text-center"> Vorteile des CVSS-Systems</h4>
            <p className="col-lg-11 text-center mx-auto">
              <strong>Vergleichbarkeit: </strong>Organisationen können die
              Schwere von Schwachstellen objektiv vergleichen.
              <br />
              <br />
              <strong>Priorisierung: </strong>Hohe Scores zeigen an, welche
              Schwachstellen zuerst behoben werden sollten.
              <br />
              <br />
              <strong>Transparenz und Konsistenz: </strong>CVSS ist ein
              international anerkannter Standard, der es Unternehmen ermöglicht,
              Sicherheitslücken auf eine Weise zu bewerten, die für alle
              Beteiligten verständlich und nachvollziehbar ist.
              <br />
              <br />
              CVSS wird in Cybersecurity-Tools implementiert, die
              Schwachstellenscans durchführen und Ergebnisse analysieren. Diese
              Tools nutzen CVSS, um Schwachstellen auf der Grundlage der
              CVSS-Metriken zu bewerten und zu priorisieren. Beispiele solcher
              Tools sind Nessus OpenVAS und QualysGuard. Diese Softwareprodukte
              führen die Berechnungen auf Basis der CVSS-Richtlinien durch und
              präsentieren den CVSS-Score als Ergebnis.
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Banken und Finanzinstitute gehören zu den am stärksten regulierten
              Branchen und müssen besonders hohe Sicherheitsstandards einhalten.
              Mehr als 80% der globalen Banken und Finanzdienstleister verwenden
              CVSS (Common Vulnerability Scoring System), um Schwachstellen in
              ihren IT-Systemen zu bewerten und zu priorisieren.
            </p>
          </div>{" "}
        </div>
      </div>

      <div className="container pt-5">
        <div
          className="safe rounded-2 text-center"
          style={{ backgroundColor: "#fec748" }}
        >
          <img
            src="/images/abwehr.svg"
            alt="Abwehr"
            style={{
              position: "relative",
              maxWidth: "7%",
              height: "auto",
            }}
          />

          <h3 className="p-5">CVSS Beispielrechner</h3>
          <p className="col-lg-11 text-start mx-auto">
            Der <strong>Basiswert </strong>ist der zentrale Wert im CVSS-System,
            der die Gesamtschwere einer Sicherheitslücke darstellt. Er wird auf
            einer Skala von 0,0 bis 10,0 angegeben und basiert auf den
            Basis-Metriken (z. B. Angriffsvektor, Komplexität, Auswirkungen auf
            Vertraulichkeit, Integrität und Verfügbarkeit).
            <br />
        
            Der Basiswert gibt an, wie kritisch die Schwachstelle insgesamt ist:
            <br />
            0,0: Keine Auswirkung (keine Gefahr) - 10,0: Kritisch (sofortiges
            Handeln erforderlich).
            <br />
         <br />
            Der <strong>Impact (Einfluss) </strong> beschreibt, wie stark eine
            Schwachstelle die Vertraulichkeit, Integrität und Verfügbarkeit
            eines Systems beeinträchtigt. Er wird als Teilwert im CVSS-Modell
            berechnet und fließt direkt in den Basiswert ein. <br />
          
            Der Impact-Wert liegt zwischen 0,0 (keine Auswirkungen) und 1,0
            (maximale Auswirkungen) und zeigt, wie gravierend die Schwachstelle
            ist, wenn sie ausgenutzt wird. <br /> <br />
            Die <strong>Exploitability (Ausnutzbarkeit) </strong> gibt an, wie
            leicht ein Angreifer die Schwachstelle ausnutzen kann. Sie hängt von
            den Faktoren wie dem Angriffsvektor, der Angriffskomplexität, den
            benötigten Berechtigungen und der Benutzereingriff ab.
            <br />
          
            Der Exploitability-Wert liegt ebenfalls zwischen 0,0 (sehr schwer
            oder unmöglich auszunutzen) und 1,0 (sehr einfach auszunutzen).
            <br />
            <br />
          </p>
          <CVSSCalculator />
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-10 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter7_3;
